export default __webpack_public_path__ + "static/media/70t.324f8d95.jpg";